import { defineComponent as t, createBlock as o, openBlock as n, unref as r, mergeProps as d, withCtx as m, createElementVNode as e } from "vue";
import { RevIcon as p } from "@ds/components/Icon";
const v = /* @__PURE__ */ t({
  name: "IconReassuranceGlobeFilled",
  __name: "IconReassuranceGlobeFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const c = l;
    return (i, a) => (n(), o(r(p), d(c, { "view-box": "0 0 48 48" }), {
      default: m(() => [...a[0] || (a[0] = [
        e("g", { "clip-path": "url(#mz490da)" }, [
          e("path", {
            "fill-rule": "evenodd",
            d: "m30.53 22.17-6.12.56-.95-12.51h1.21a21.2 21.2 0 0 1 5.7.78 58.787 58.787 0 0 1 3.07 9.16l.33 1.74-2.17.2a98.159 98.159 0 0 1 .218-.475c.174-.376.336-.725.492-1.095a.25.25 0 0 0-.29-.36.25.25 0 0 0-.15.12c-.44.64-.88 1.28-1.34 1.88m-2.16-5.96c-.87-1.27-2.12-1.93-2.79-1.48V14.7c-.67.46-.51 1.9.36 3.17s2.15 1.93 2.79 1.47c.64-.46.51-1.86-.36-3.13m-12.96-3.9a21.35 21.35 0 0 1 7.06-1.93l.94 12.44-9.76.89a21.636 21.636 0 0 1-.07-3.22 30.109 30.109 0 0 1 1.83-8.18m2.79 6.28c.79 1.39 1.95 2.22 2.6 1.85.65-.37.53-1.8-.25-3.18-.78-1.38-1.94-2.22-2.59-1.85-.65.37-.55 1.79.24 3.18",
            "clip-rule": "evenodd"
          }),
          e("path", { d: "M29.15 23.79a7.826 7.826 0 0 0 .358-.39 24.435 24.435 0 0 1 .122-.14l-5.15.47.26 3.37a8.735 8.735 0 0 0 1-.58 15.52 15.52 0 0 0 3.41-2.73m-2.75 3.76a12.998 12.998 0 0 0 3.6-3 9.584 9.584 0 0 0 1-1.42l2.98-.33v.1c.74 4.76.28 9.36-1.26 12.68a21.343 21.343 0 0 1-7.2 2l-.7-9.25a13.603 13.603 0 0 0 1.58-.78m8.02-7.64c.15.62.27 1.24.38 1.84l6.44-.58c-1-4.44-4.66-8-9.62-9.77a57.374 57.374 0 0 1 2.8 8.51m-21.63 4.94V25a25 25 0 0 0 5.98 12.24C12.06 35.78 7 31.18 6.56 25.42l6.23-.57m-.14-1.04a23.755 23.755 0 0 1-.07-3.37A30.654 30.654 0 0 1 14.11 13c-4.56 2.6-7.53 6.79-7.59 11.39l6.13-.58" }),
          e("path", { d: "m35 22.77 6.4-.58a4.002 4.002 0 0 0 .04.24 4.002 4.002 0 0 1 .04.24 12.35 12.35 0 0 1-4.34 10 17.895 17.895 0 0 1-3 2.2A24.51 24.51 0 0 0 35 22.77m-11.14 5.98a13.198 13.198 0 0 1-1.84.5 13.461 13.461 0 0 1-4.65.16.2.2 0 0 1-.16-.23.18.18 0 0 1 .18-.16 19.492 19.492 0 0 0 4.37-.74 19.726 19.726 0 0 0 2-.73l-.28-3.73-9.72.89v.11a24.52 24.52 0 0 0 6.58 12.71 23.114 23.114 0 0 0 4.18.17l-.66-8.95" }),
          e("path", {
            "fill-rule": "evenodd",
            d: "M10.666 4.045a24 24 0 1 1 26.668 39.91 24 24 0 0 1-26.668-39.91M33.38 36.43a19 19 0 0 0 4.42-3 13.33 13.33 0 0 0 4.65-10.83 4.273 4.273 0 0 0-.062-.387c-.034-.18-.068-.358-.068-.533v-.21c-.93-5.29-5.34-9.51-11.34-11.29a.46.46 0 0 0-.25-.08 22.7 22.7 0 0 0-15.8 1.34.49.49 0 0 0-.22.1c-5.61 2.77-9.29 7.75-9.17 13.22a.64.64 0 0 0 0 .2v.44C6 32.11 12.18 37.35 20.13 38.48h.08a22.425 22.425 0 0 0 3.2.23 25.59 25.59 0 0 0 1.74-.06 22.22 22.22 0 0 0 8.23-2.22",
            "clip-rule": "evenodd"
          })
        ], -1),
        e("defs", null, [
          e("clipPath", { id: "mz490da" }, [
            e("path", { d: "M0 0h48v48H0z" })
          ])
        ], -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  v as default
};
